<template>
  <div class="ap-login-layout">
    <div>
      <ap-language-switch/>
      <ap-header />
      <div
        class="container ba-flex ba-justify-center ba-flex-wrap ba-py-10 ba-content-center md:ba-content-start"
      >
        <main class="ap-login-layout__main">
          <div
            class="md:ba-relative md:ba-z-50 md:ba-w-full md:ba-h-full md:ba-overflow-y-auto ba-py-16 md:ba-py-16"
          >
            <img
              v-if="false"
              src="/img/rhombus.svg"
              class="ba-hidden lg:ba-block ba-absolute ba-bottom-1/5 ba-right-10 xl:ba--right-1/12"
            />
            <img
              v-if="false"
              src="/img/stairs.svg"
              class="ba-hidden lg:ba-block ba-absolute ba-bottom-1/5 ba--left-1/6"
            />
            <slot />
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import ApHeader from "@/components/artek/ap-header";
import ApLanguageSwitch from "@/components/artek/ap-language-switch";

export default {
  name: "vis-login-layout",
  components: {
    ApLanguageSwitch,
    ApHeader
  }
};
</script>
